import { Container } from 'aurelia-dependency-injection';
import { AureliaConfiguration } from 'aurelia-configuration';

export const loadCanvasCss = async ({ editor, website }) => {
    // const [icons] = Promise.all([
    //     import(`WordPressCMS/wp-includes/css/dashicons.css`).catch(() => ([])),
    // ]);

    const canvasStyles = `
    html{

        --gjs-primary-color: #18181b;

    }

    a {
            color: #c45453;
            text-decoration: none;
    }

      .sio-text.gjs-selected{
        padding-left: 5px;
        padding-right: 5px;
      }



      /* Layout */

      .gjs-dashed .container, .gjs-dashed .container-fluid,
      .gjs-dashed .row,
      .gjs-dashed .col, .gjs-dashed [class^="col-"] {
        min-height: 1.5rem !important;
      }

      .gjs-dashed .w-100 {
        min-height: .25rem !important;
        background-color: rgba(0,0,0,0.1);
      }
      .gjs-dashed img {
        min-width: 25px;
        min-height: 25px;
        background-color: rgba(0,0,0,0.5);
      }

      .gjs-row{display:table;padding-top:10px;padding-right:10px;padding-bottom:10px;padding-left:10px;width:100%;}

      /* Components */

      .gjs-dashed .btn-group,
      .gjs-dashed .btn-toolbar {
        padding-right: 1.5rem !important;
        min-height: 1.5rem !important;
      }
      .gjs-dashed .card,
      .gjs-dashed .card-group, .gjs-dashed .card-deck, .gjs-dashed .card-columns {
        min-height: 1.5rem !important;
      }
      .gjs-dashed .collapse {
        display: block !important;
        min-height: 1.5rem !important;
      }
      .gjs-dashed .dropdown {
        display: block !important;
        min-height: 1.5rem !important;
      }
      .gjs-dashed .dropdown-menu {
        min-height: 1.5rem !important;
        display: block !important;
      }

      .gjs-selected {
            outline: 2px solid #3b97e3 !important;
            outline-offset: -2px;
        }

        .swiper-slide:empty:before, .login-modal:empty:before, .sio-div:empty:before, .hover-container:empty:before,.accordion-body:empty:before,[data-gjs-type="column"]:empty:before, [data-gjs-type="row"]:empty:before, .gjs-row [data-gjs-type="default"]:empty:before,[data-gjs-type="link-box"]:empty:before,.container:empty:before, [data-gjs-type="grid"]:empty:before, [data-gjs-type="dynamic-columns"]:empty:before, .tabs-btn:empty:before, .tabs-panel:empty:before {
                background-color: #ddd;
                color: #000;
                font-size: 16px;
                font-weight: bold;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                min-height: 30px;
                padding: 10px 16px;
                opacity: 0.3;
                border-radius: 3px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                content: "Grid";
            }
            .hover-container:empty:before{
                content: "Drop Content";
            }
            .gjs-row [data-gjs-type="default"]:empty:before{
                content: "Column";
            }
          [data-gjs-type="dynamic-columns"]:empty:before {
            content: "Columns";
            }

             .sio-div:empty:before {
                content: "Div";
            }
            .tabs-btn:empty:before {
              content: "Tab Button";
            }
            .tabs-panel:empty:before {
              content: "Tab Panel";
            }

            .swiper-slide:empty {
                min-height: 360px;
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
            }

            .swiper-slide:empty:before {
                content: "Inhalt hier einfügen";
                width: 100%;
            }
            .swiper-slide {
                min-height: 160px;
            }
            /* Slider toolbar – fixed-positioned, appended to canvas body via JS */
            .sio-swiper-editor-topbar {
                position: fixed;
                z-index: 9999;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                gap: 12px;
                min-height: 44px;
                min-width: 0;
                max-width: calc(100vw - 24px);
                padding: 0 12px;
                background: #1A1A1B;
                border-radius: 12px;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
                box-sizing: border-box;
                font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "SF Pro", sans-serif;
                font-size: 14px;
                font-weight: 500;
                user-select: none;
                overflow: hidden;
            }

            /* Left: Pagination pill */
            .sio-swiper-editor-topbar__pagination {
                display: flex;
                align-items: center;
                gap: 2px;
                flex: 1 1 0%;
                min-width: 0;
                max-width: 100%;
                overflow: hidden;
                background: rgba(255, 255, 255, 0.06);
                border-radius: 10px;
                padding: 4px 6px;
            }

            .sio-swiper-editor-topbar__numbers {
                display: flex;
                align-items: center;
                gap: 2px;
                flex: 1 1 0%;
                min-width: 0;
                overflow-x: auto;
                scrollbar-width: none;
            }

            .sio-swiper-editor-topbar__numbers::-webkit-scrollbar {
                display: none;
            }

            /* Center: Status indicator */
            .sio-swiper-editor-topbar__status {
                flex: 0 1 auto;
                min-width: 0;
                color: rgba(255, 255, 255, 0.7);
                font-size: 13px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            /* Right: Action hub */
            .sio-swiper-editor-topbar__actions {
                display: flex;
                align-items: center;
                gap: 4px;
                flex: 0 0 auto;
                flex-shrink: 0;
                margin-left: auto;
            }

            .sio-swiper-editor-topbar__btn {
                border: 0;
                background: transparent;
                color: rgba(255, 255, 255, 0.85);
                min-width: 36px;
                width: 36px;
                height: 36px;
                padding: 0;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                border-radius: 10px;
                cursor: pointer;
                transition: background 0.15s ease, color 0.15s ease;
            }

            .sio-swiper-editor-topbar__btn:hover {
                background: rgba(255, 255, 255, 0.12);
                color: #fff;
            }

            .sio-swiper-editor-topbar__btn svg {
                width: 18px;
                height: 18px;
                stroke-width: 2;
            }

            .sio-swiper-editor-topbar__btn--arrow {
                flex-shrink: 0;
            }

            .sio-swiper-editor-topbar__btn--number {
                min-width: 32px;
                width: auto;
                flex-shrink: 0;
                padding: 0 8px;
                font-size: 13px;
            }

            .sio-swiper-editor-topbar__btn--number:hover {
                background: rgba(255, 255, 255, 0.1);
            }

            .sio-swiper-editor-topbar__btn--active,
            .sio-swiper-editor-topbar__btn--active:hover {
                background: rgba(255, 255, 255, 0.18);
                color: #fff;
                text-decoration: underline;
                text-underline-offset: 3px;
            }

            .sio-swiper-editor-topbar__btn--arrow svg,
            .sio-swiper-editor-topbar__btn--move svg,
            .sio-swiper-editor-topbar__btn--control svg {
                width: 18px;
                height: 18px;
            }

            .sio-swiper-editor-topbar__btn--disabled,
            .sio-swiper-editor-topbar__btn--disabled:hover {
                color: rgba(255, 255, 255, 0.35);
                background: transparent;
                cursor: not-allowed;
            }

             .container:empty:before {
                content: "Container";
            }
                [data-gjs-type="login-modal"]:empty:before {
            content: "Login Modal Opener";
            }

            [data-gjs-type="row"]:empty:before{
                    content: "Flex Row";
            }

            [data-gjs-type="blogsList"]:empty:before{
                content: "Blogs List";
                width: 90%;
                margin: auto;
                min-height: 160px;
            }

            [data-gjs-type="column"]:empty:before{
                    content: "Flex Column";
            }

             .accordion-body:empty:before {
                content: "Accordion Body, Drop Components here";
            }

             [data-gjs-type="link-box"]:empty:before {
                content: "Link Box";
            }



            .acc-collapse {
                    display: block;
                    height: 0;
                    overflow: hidden;
                    transition: max-height 0.3s ease;
                }

                .acc-collapse.acc-show {
                    height: 100%;
                }

             /* Animation for accordion icons */
            .accordion .card-header[aria-expanded=true] .accordion-icon {
                transform: rotate(180deg);
            }

            /* Breadcrumb Styles */
            .cms-breadcrumbs {
              --separator: ">";
            }





            .cms-breadcrumbs__li:not(:last-child)::after {
              content: var(--separator);
                margin-left: 0.5rem;
                }
            .cms-breadcrumbs{
                >:not([hidden])~:not([hidden]) {
                    margin-left: 0.5rem;
                }
            }

            .cms-breadcrumbs__item{
                color: black!important;
            }





            /* Gallery */
            .gallery-item:empty:empty {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
                background-color: #ddd;
                color: #000;
                opacity: 0.3;
            }
            .gallery-item:empty:empty:before {
              content: 'Galelery Item';
              font-weight: bold;
            }

            /* Responsive design */
            @media (max-width: 768px) {
              .cms-breadcrumbs__ol {
                font-size: 12px;
              }

              .cms-breadcrumbs__li:not(:last-child)::after {
                margin: 0 0.25rem;
              }
            }

            ul,
            ol {
                list-style-type: disc;
                padding-left: 20px;
                margin: 12px 0;

                li {
                    display: list-item;
                    padding: 2px 0;
                }
            }

            ol {
                list-style-type: decimal;
            }

    `;
    let isThemeStylesAdded = false;
    const loadThemeStyles = async () => {
        try {
            const myHeaders = new Headers();
            myHeaders.append('Content-Type', 'application/json');
            myHeaders.append('Authorization', 'Basic c2lvOnNpbw==');

            const isLocalhost =
                Container.instance.get(AureliaConfiguration).get('apiUrl') ===
                'https://127.0.0.1:8000/api/v2/';

            const isDev = isLocalhost;
            const url = isDev
                ? `http://localhost:3000/api/styles`
                : `${website.url}/api/styles`;
            const response = await fetch(url, {
                method: 'GET',
                headers: myHeaders,
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const parsedStyles = await response.json();
            return parsedStyles?.styles?.css || '';
        } catch (error) {
            return '';
        }
    };

    try {
        const themeStyles = await loadThemeStyles();
        const combinedStyles = `${themeStyles} ${canvasStyles}`;

        if (!editor.Config) {
            editor.Config = {};
        }

        editor.Config.canvasCss =
            (editor.Config.canvasCss || '') + combinedStyles;

        const applyStylesToCanvas = () => {
            try {
                const canvas = editor.Canvas.getDocument();
                if (canvas && canvas.head && !isThemeStylesAdded) {
                    const style = canvas.createElement('style');
                    style.innerHTML = combinedStyles;
                    canvas.head.appendChild(style);
                    isThemeStylesAdded = true;
                }
            } catch (err) { }
        };

        applyStylesToCanvas();

        editor.on('canvas:frame:load', applyStylesToCanvas);
        editor.on('load', applyStylesToCanvas);
    } catch (error) {
        console.error('Error loading canvas CSS:', error);
    }
};
